<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.1 519.8">
    <g>
      <g>
        <path
          d="M145.6,245.4l-33.8-19.5L0,419.5l53.8,31.1L128.6,321l-8.4-31.5L145.6,245.4L145.6,245.4z" />
        <path d="M90.7,78L13.9,211l38.3,58l84.5-146.4L90.7,78z" />
        <path d="M285.4,326.2l-33.8-19.5l-25.4,44l-31.5,8.4l-74.9,129.6l53.8,31.1L285.4,326.2z" />
        <path d="M424.1,270.5l-61.6-17.6L278,399.3l69.3,4.2L424.1,270.5L424.1,270.5z" />
      </g>
    </g>
    <g>
      <path
        d="M369.7,81.8l-88.5-51.1l-43,28.4L135.7,0l-30.2,52.3l68.4,66.1l-33.9,58.8l29.3,44.4l-15.1,73.9l49.9,28.8l56.4-50
		l53.1,3.2l33.9-58.8l91.4,26.2l30.2-52.3l-102.5-59.2L369.7,81.8z M277.7,139l42.7-11.4l4.6,17.1l-42.7,11.4l11.5,42.7l-17.1,4.6
		l-11.4-42.7l-42.7,11.4l-4.6-17.1l42.7-11.4l-11.4-42.7l17.1-4.6L277.7,139L277.7,139z" />
    </g>
  </svg>
</template>
